import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Tag } from '../models/tag.entity'

export type TagNotificationCode =
  | GenericNotificationCode
  | 'TAG_DELETED'
  | 'TAG_SAVED'

export type TagModalCode = 'TAG_DELETION'

/**
 * Parse tag code to a notification
 * @param code - the tag notification code
 * @returns the notification options
 */
export function parseTagNotification(
  code?: TagNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'TAG_DELETED':
      return {
        message: 'Tag deleted successfully',
        color: 'success',
      }
    case 'TAG_SAVED':
      return {
        message: 'Tag saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse tag code to an modal
 * @param code - the tag modal code
 * @param tag - the tag object
 * @returns the modal settings
 */
export function parseTagModal(code: TagModalCode, tag?: Tag): DialogOptions {
  switch (code) {
    case 'TAG_DELETION': {
      const value = tag?.value
      return {
        title: 'Delete tag',
        message:
          'You are about to delete the tag <strong>%s</strong>. Proceed with deletion?',
        messageParams: value ? [value] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }

    default:
      return {}
  }
}
